
/* REPORT */
export const GET_SALES_PERFORMANCE = "GET_SALES_PERFORMANCE";
export const GET_SALES_PERFORMANCE_SUCCESS = "GET_SALES_PERFORMANCE_SUCCESS";
export const GET_SALES_PERFORMANCE_FAIL = "GET_SALES_PERFORMANCE_FAIL";

export const GET_DOCTOR_PERFORMANCE = "GET_DOCTOR_PERFORMANCE";
export const GET_DOCTOR_PERFORMANCE_SUCCESS = "GET_DOCTOR_PERFORMANCE_SUCCESS";
export const GET_DOCTOR_PERFORMANCE_FAIL = "GET_DOCTOR_PERFORMANCE_FAIL";

export const GET_DOCTOR_REPORT_DETAILS = "GET_DOCTOR_REPORT_DETAILS";
export const GET_DOCTOR_REPORT_DETAILS_SUCCESS = "GET_DOCTOR_REPORT_DETAILS_SUCCESS";
export const GET_DOCTOR_REPORT_DETAILS_FAIL = "GET_DOCTOR_REPORT_DETAILS_FAIL";

export const GET_DOCTOR_PAYMENT_REPORT_DETAILS = "GET_DOCTOR_PAYMENT_REPORT_DETAILS";
export const GET_DOCTOR_PAYMENT_REPORT_DETAILS_SUCCESS = "GET_DOCTOR_PAYMENT_REPORT_DETAILS_SUCCESS";
export const GET_DOCTOR_PAYMENT_REPORT_DETAILS_FAIL = "GET_DOCTOR_PAYMENT_REPORT_DETAILS_FAIL";

export const GET_PAY_COMMISSION_REPORT = "GET_PAY_COMMISSION_REPORT";
export const GET_PAY_COMMISSION_REPORT_SUCCESS = "GET_PAY_COMMISSION_REPORT_SUCCESS";
export const GET_PAY_COMMISSION_REPORT_FAIL = "GET_PAY_COMMISSION_REPORT_FAIL";

export const EXPORT_DOCTOR_PERFORMANCE = "EXPORT_DOCTOR_PERFORMANCE";
export const EXPORT_DOCTOR_PERFORMANCE_SUCCESS = "EXPORT_DOCTOR_PERFORMANCE_SUCCESS";
export const EXPORT_DOCTOR_PERFORMANCE_FAIL = "EXPORT_DOCTOR_PERFORMANCE_FAIL";

export const EXPORT_DOCTOR_SALES = "EXPORT_DOCTOR_SALES";
export const EXPORT_DOCTOR_SALES_SUCCESS = "EXPORT_DOCTOR_SALES_SUCCESS";
export const EXPORT_DOCTOR_SALES_FAIL = "EXPORT_DOCTOR_SALES_FAIL";

export const RESET_REPORT_STATE = 'RESET_REPORT_STATE';
export const RESET_REPORT_ACTION_STATE = 'RESET_REPORT_ACTION_STATE';